"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FamilyContractRequest = void 0;
var FamilyContractRequest = /** @class */ (function () {
    function FamilyContractRequest() {
    }
    return FamilyContractRequest;
}());
exports.FamilyContractRequest = FamilyContractRequest;
;
//# sourceMappingURL=familyContract.request.js.map